import { render, staticRenderFns } from "./DialogCalendarFields.vue?vue&type=template&id=2cdaf136"
import script from "./DialogCalendarFields.vue?vue&type=script&lang=js"
export * from "./DialogCalendarFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports